import type { ReactNode } from 'react';

export const symbol_currency_yen: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M450-150v-120H270q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h180v-100H270q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h151L229-794q-10-15-1.47-30.5 8.52-15.5 26.31-15.5 8.16 0 15.2 3.68 7.05 3.69 10.96 10.32l200 317 200-317q3.82-6.63 10.71-10.32Q697.59-840 706-840q17.87 0 26.44 15.5Q741-809 731-794L539-490h151q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H510v100h180q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H510v120q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37Z"
		/>
	</svg>
);
